/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Preferences/view.blocks to change it.
import Preference from './Preference/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Preferences({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/ToggleLocationConnection/SetupAutomations/Content/Content/Content/Steps/Content/ActiveStep/Preferences"
  
}) {
  return (<React.Fragment
>
<Preference
  viewPath={`${viewPath}/Preference`}
/>
{children}
</React.Fragment>)
}